<!--
 * @Author: Tahiti
 * @Date: 2025-10-21 14:34:38
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-30 17:45:33
 * @Description: 
 * @FilePath: /weryai-web/components/Tool/Image-to-Video-Setting.vue
-->
<template>
    <div
        class="relative z-20 flex shrink-0 flex-col justify-between bg-setting-bg max-h-[inherit] w-full overflow-y-auto rounded-lg p-4 lg:p-6 lg:pb-0 lg:!w-[424px] lg:border-r lg:border-r-[#1D1D20]">
        <!-- 设置最小高度减少 CLS 布局偏移 -->
        <div>
            <span class="hidden lg:block text-white cursor-default text-base font-semibold md:text-lg mb-[30px]">
                {{ t('menus.imageToVideo') }}
            </span>
            <tool-model-select v-model:model="edit_model" :model_list="modelList"
                :type="props.type"></tool-model-select>
            <!-- 使用 v-show 替代 v-if 减少 CLS 布局偏移 -->
            <tool-model-version v-show="currentModelList?.length" v-model:model_version="model_version"
                :model_version_list="currentModelList || []"></tool-model-version>
            <div v-if="supportsAlmightyReference" class="mt-5 almighty-mode-switch">
                <div class="almighty-mode-switch__tabs">
                    <button type="button" class="almighty-mode-switch__tab" :class="{
                        'almighty-mode-switch__tab--active':
                            is_seedance_allround_mode,
                    }" @click="activateAlmightyMode()">
                        {{ almightyModeText }}
                    </button>
                    <button type="button" class="almighty-mode-switch__tab" v-if="is_support_first_last_frame" :class="{
                        'almighty-mode-switch__tab--active':
                            !is_seedance_allround_mode,
                    }" @click="activateFirstLastMode">
                        {{ firstLastModeText }}
                    </button>
                </div>
            </div>
            <!-- 使用 v-show 减少 CLS 布局偏移 -->
            <tool-set-img-mult-or-one v-show="is_support_multiple_images &&
                !is_seedance_allround_mode &&
                !supportsAlmightyReference
                " v-model:image_type="image_type"></tool-set-img-mult-or-one>
            <!-- 图片上传区域 - 使用固定高度容器包裹减少 CLS -->
            <div class="min-h-[167px]">
                <tool-almighty-reference-uploader v-if="is_seedance_allround_mode"
                    v-model:items="almighty_reference_items"
                    v-model:busy="almighty_busy"
                    :model-key="effectiveModelKey"></tool-almighty-reference-uploader>
                <tool-image-frame-and-end-upload v-else-if="
                    supportsAlmightyReference &&
                    image_type === 'single_frame' &&
                    frame_end_mode
                " v-model:first_image_url="first_image_url" v-model:last_image_url="last_image_url"
                    v-model:frame_end_mode="frame_end_mode"></tool-image-frame-and-end-upload>
                <tool-image-upload-mult v-else-if="is_show_multiple_images_upload" v-model:image_list="image_list"
                    v-model:upload_image_limit="upload_image_limit"></tool-image-upload-mult>
                <tool-image-upload-single v-else-if="
                    !is_show_multiple_images_upload &&
                    image_type === 'single_frame' &&
                    !frame_end_mode
                " v-model:image_url="image_url" v-model:frame_end_mode="frame_end_mode"
                    v-model:is_support_first_last_frame="is_support_first_last_frame
                        "></tool-image-upload-single>
                <tool-image-frame-and-end-upload v-else-if="
                    !is_show_multiple_images_upload &&
                    image_type === 'single_frame' &&
                    frame_end_mode
                " v-model:first_image_url="first_image_url" v-model:last_image_url="last_image_url"
                    v-model:frame_end_mode="frame_end_mode"></tool-image-frame-and-end-upload>
            </div>

            <div v-if="isSora2"
                class="flex gap-x-[10px] text-[#fb9d4f] text-[10px] font-normal mt-[5px] rounded-[7px] border border-[rgba(154,52,18,0.3)] bg-[rgba(124,45,18,0.1)] py-[10px] px-[5px]">
                <svg class="shrink-0" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"
                    fill="none">
                    <path
                        d="M6.99999 12.8327C10.2217 12.8327 12.8333 10.221 12.8333 6.99935C12.8333 3.77769 10.2217 1.16602 6.99999 1.16602C3.77833 1.16602 1.16666 3.77769 1.16666 6.99935C1.16666 10.221 3.77833 12.8327 6.99999 12.8327Z"
                        stroke="#fb9d4f" stroke-opacity="0.9" stroke-width="1.16667" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M7 9.33333V7" stroke="#fb9d4f" stroke-opacity="0.9" stroke-width="1.16667"
                        stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M7 4.66602H7.00583" stroke="#fb9d4f" stroke-opacity="0.9" stroke-width="1.16667"
                        stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {{ t('sora2.sora2Tip') }}
            </div>

            <template v-if="is_seedance_allround_mode">
                <div class="mt-5">
                    <div class="flex items-center justify-between gap-2 mb-[10px]">
                        <label class="block text-white text-sm">
                            {{ t('tools.prompt') }}
                        </label>
                    </div>
                    <div class="allround-prompt-shell">
                        <AlmightyMentionEditor v-model:prompt="edit_prompt" v-model:tokens="almighty_prompt_tokens"
                            :assets="almightyMentionAssets" :max-length="ALMIGHTY_PROMPT_MAX_LENGTH"
                            :placeholder="almightyPromptPlaceholder" />
                        <div class="allround-prompt-shell__actions">
                            <ClientOnly>
                                <el-tooltip v-model:visible="allroundRecommendVisible" effect="dark" trigger="hover"
                                    :placement="isLt1024 ? 'bottom' : 'right'"
                                    :disabled="allroundRecommendTooltipDisabled" :enterable="true"
                                    popper-class="prompt-popper" :popper-style="recommendPopperStyle">
                                    <span v-if="!allroundRecommendLoading" class="allround-prompt-shell__action"
                                        @click.stop.prevent="handleClickAllroundRecommendPrompt">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 16 16" fill="none" class="w-4 h-4">
                                            <path
                                                d="M3.14227 4.75207L2.97788 5.12919C2.85758 5.40528 2.47571 5.40528 2.35541 5.12919L2.19104 4.75207C1.89804 4.07965 1.3703 3.54427 0.71178 3.25139L0.205365 3.02615C-0.0684548 2.90435 -0.0684548 2.50587 0.205365 2.38408L0.683467 2.17143C1.35892 1.87101 1.89611 1.31582 2.18408 0.620552L2.35288 0.213023C2.47052 -0.0710075 2.86278 -0.0710075 2.98042 0.213023L3.14921 0.620552C3.43718 1.31582 3.97439 1.87101 4.64987 2.17143L5.12792 2.38408C5.40181 2.50587 5.40181 2.90435 5.12792 3.02615L4.62152 3.25139C3.96301 3.54427 3.43525 4.07965 3.14227 4.75207ZM10.2096 6.35523L10.3043 6.44994C11.1675 7.34533 11.5537 8.65787 11.2084 9.94673C10.7763 11.5595 9.31347 12.6656 7.66773 12.6656C6.31048 12.6656 4.52565 12.2484 3.01907 11.6561C3.82299 10.7131 4.11615 9.78333 4.219 8.53667C4.24383 8.23573 4.25934 8.11607 4.2879 8.00947C4.81694 6.03507 6.67787 4.93677 8.61567 5.45599C9.2366 5.62238 9.7774 5.93855 10.2096 6.35523ZM12.1519 1.58087L8.85907 4.14193C6.22816 3.49282 3.70562 5.03097 3 7.6644C2.93217 7.91753 2.91098 8.17467 2.88878 8.444C2.81219 9.37327 2.72369 10.4471 0.666667 11.9977C2.33333 12.9977 5.33333 13.9989 7.66773 13.9989C9.87613 13.9989 11.8975 12.5264 12.4963 10.2918C12.7224 9.44793 12.7185 8.59667 12.5231 7.80447L15.0835 4.51253C15.2899 4.24713 15.2665 3.86957 15.0287 3.63183L13.0325 1.6357C12.7948 1.39796 12.4173 1.37445 12.1519 1.58087ZM11.2635 5.52347C11.2213 5.47968 11.1782 5.43663 11.1343 5.39433L10.3846 4.64457L12.5059 2.99465L13.6697 4.15849L12.0198 6.27981L11.2635 5.52347Z"
                                                fill="currentColor" />
                                        </svg>
                                        {{ t('tools.recommendPrompt') }}
                                    </span>
                                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="14" height="14"
                                        viewBox="0 0 14 14" fill="none"
                                        class="w-4 h-4 loading hover:text-white cursor-pointer">
                                        <path
                                            d="M2.30838 1.62175C3.47704 0.611253 5.00047 0 6.66667 0C10.3485 0 13.3333 2.98477 13.3333 6.66667C13.3333 8.09073 12.8868 9.41053 12.1261 10.4937L10 6.66667H12C12 3.72115 9.6122 1.33333 6.66667 1.33333C5.23321 1.33333 3.93185 1.89885 2.97349 2.81895L2.30838 1.62175ZM11.0249 11.7116C9.85627 12.7221 8.33287 13.3333 6.66667 13.3333C2.98477 13.3333 0 10.3485 0 6.66667C0 5.24257 0.446527 3.92277 1.2072 2.83963L3.33333 6.66667H1.33333C1.33333 9.6122 3.72115 12 6.66667 12C8.10013 12 9.40147 11.4345 10.3599 10.5144L11.0249 11.7116Z"
                                            fill="currentColor" />
                                    </svg>
                                    <template #content>
                                        <div
                                            class="flex flex-col gap-[30px] min-w-[300px] md:max-w-[400px] max-w-[350px] min-h-[300px] max-h-[600px] overflow-y-auto">
                                            <div v-if="allroundRecommendLoading" class="w-full h-full">
                                                <l-dot-spinner v-if="isClient" size="40" speed="0.9"
                                                    color="var(--el-menu-active-color)"></l-dot-spinner>
                                            </div>
                                            <div v-else-if="!recommend_list || recommend_list.length === 0"
                                                class="text-white/80 text-sm">
                                                {{ t('batchTools.noRecommend') }}
                                            </div>
                                            <div v-else class="flex flex-col items-start gap-[30px]">
                                                <div v-for="(item, idx) in recommend_list" :key="idx"
                                                    class="flex flex-col items-start gap-[10px]">
                                                    <p>{{ item }}</p>
                                                    <button type="button"
                                                        class="border border-transparent bg-[#4D505D] rounded-[6px] px-4 py-[6px] hover:border-white/30 hover:text-text-active transition duration-300"
                                                        @click.stop.prevent="applyAllroundRecommendPrompt(item as string)">
                                                        {{ t('common.use') }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </el-tooltip>
                                <template #fallback>
                                    <span v-if="!allroundRecommendLoading" class="allround-prompt-shell__action"
                                        @click="handleClickAllroundRecommendPrompt">
                                        {{ t('tools.recommendPrompt') }}
                                    </span>
                                </template>
                            </ClientOnly>
                            <span class="allround-prompt-shell__action" @click="handleShowAllroundAIReversal">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 14 12"
                                    fill="none">
                                    <path
                                        d="M10.158 0.2C10.41 0.2 10.631 0.437 10.631 0.708V4.429H13.534C13.628 4.429 13.724 4.464 13.786 4.531C14.006 4.701 14.07 5.005 13.913 5.241L10.221 11.163C10.1854 11.233 10.1314 11.2921 10.0648 11.3338C9.99821 11.3755 9.92156 11.3984 9.843 11.4C9.59 11.4 9.369 11.163 9.369 10.893V7.17H6.466C6.41928 7.17095 6.37285 7.1624 6.32953 7.14487C6.28621 7.12733 6.24691 7.10118 6.214 7.068C6.1061 6.98828 6.03289 6.87021 6.00945 6.73812C5.98601 6.60603 6.01412 6.46998 6.088 6.358L9.779 0.436C9.81473 0.36583 9.86888 0.306704 9.93564 0.264954C10.0024 0.223205 10.0793 0.200406 10.158 0.199V0.2ZM0.7 0H6.3C6.48565 0 6.6637 0.0737497 6.79498 0.205025C6.92625 0.336301 7 0.514348 7 0.7C7 0.885652 6.92625 1.0637 6.79498 1.19497C6.6637 1.32625 6.48565 1.4 6.3 1.4H0.7C0.514349 1.4 0.336301 1.32625 0.205025 1.19497C0.0737497 1.0637 0 0.885652 0 0.7C0 0.514348 0.0737497 0.336301 0.205025 0.205025C0.336301 0.0737497 0.514349 0 0.7 0ZM0.7 10H6.3C6.48565 10 6.6637 10.0737 6.79498 10.205C6.92625 10.3363 7 10.5143 7 10.7C7 10.8857 6.92625 11.0637 6.79498 11.195C6.6637 11.3263 6.48565 11.4 6.3 11.4H0.7C0.514349 11.4 0.336301 11.3263 0.205025 11.195C0.0737497 11.0637 0 10.8857 0 10.7C0 10.5143 0.0737497 10.3363 0.205025 10.205C0.336301 10.0737 0.514349 10 0.7 10ZM0.7 5H3.3C3.48565 5 3.6637 5.07375 3.79498 5.20503C3.92625 5.3363 4 5.51435 4 5.7C4 5.88565 3.92625 6.0637 3.79498 6.19497C3.6637 6.32625 3.48565 6.4 3.3 6.4H0.7C0.514349 6.4 0.336301 6.32625 0.205025 6.19497C0.0737497 6.0637 0 5.88565 0 5.7C0 5.51435 0.0737497 5.3363 0.205025 5.20503C0.336301 5.07375 0.514349 5 0.7 5Z"
                                        fill="currentColor" />
                                </svg>
                                {{ t('common.aiReversalShort') }}
                            </span>
                        </div>
                    </div>
                    <ui-prompt-reversal v-model:visible="allroundAiReversalVisible"
                        @apply="handleApplyAllroundReversalPrompt"></ui-prompt-reversal>
                </div>
            </template>
            <tool-prompt-textarea v-else v-model:prompt="edit_prompt" :recommend_list="recommend_list"
                v-model:prompt_length_limit="prompt_length_limit"></tool-prompt-textarea>
            <tool-prompt-textarea v-show="has_negative_prompt && !is_seedance_allround_mode"
                v-model:prompt="negative_prompt" :title="t('tools.negativePrompt')"
                :placeholder="t('tools.describeNegativePrompt')" :is_show_recommend="false"
                v-model:prompt_length_limit="prompt_length_limit"></tool-prompt-textarea>
            <tool-aspect-radio v-show="shouldShowAspectRatio" v-model:aspect_ratio="edit_aspect_ratio"
                :aspect_ratio_list="displayedAspectRatioList" :disabled_ratios="disabledAspectRatios"></tool-aspect-radio>
            <!-- Runway / Seedance 2.0 模型使用滑块选择时长 -->
            <tool-duration-slider v-if="supportsDurationSlider && durationList?.length" v-model:duration="duration"
                :min="durationSliderMin" :max="durationSliderMax" :step="1"
                :default-value="durationSliderDefaultValue"></tool-duration-slider>
            <!-- 其他模型使用原有的按钮选择时长 -->
            <tool-durations v-else-if="durationList?.length" v-model:duration="duration"
                :duration_list="durationList || []"></tool-durations>
            <tool-video-size v-show="resolutionList?.length" v-model:video_size="video_size"
                :video_size_list="resolutionList || []"></tool-video-size>
            <tool-image-number create_type="VIDEO"
                v-model:output_image_number="edit_output_image_number"></tool-image-number>
            <tool-video-audio v-show="has_generate_audio" v-model:generate_audio="generate_audio"></tool-video-audio>
            <tool-public-visibility v-model:public_visible="public_visible"></tool-public-visibility>
            <tool-copyright-protection v-model:copyright_protection="copyright_protection"></tool-copyright-protection>
        </div>
        <tool-credit-required class="relative z-30 lg:sticky lg:bottom-0 lg:py-4 lg:!mb-0 bg-setting-bg" :type="props.type"
            :create_btn_disable="props.create_btn_disable ||
                (is_seedance_allround_mode && almighty_busy)
                " :workflowType="currentWorkflowType" :m="model_version || edit_model" :p="edit_aspect_ratio"
            :n="edit_output_image_number" :t="creditDuration" :ga="has_generate_audio ? generate_audio : false"
            :r="video_size" :loading="props.create_loading"></tool-credit-required>
    </div>
</template>
<script setup lang="ts">
import { computed, nextTick, ref, watch, onMounted, onUnmounted } from 'vue'
import { useI18n } from '~/composables/useI18n'
import type { SettingType } from '~/types'
import { ModelType } from '~/types'
import { useAppStore } from '~/stores/app'
import AlmightyMentionEditor from '~/components/Tool/AlmightyMentionEditor.vue'
import type { AlmightyReferenceItem } from '~/utils/almightyReference'
import { toAlmightyRequestDuration } from '~/utils/almightyReference'
import {
    buildAlmightyMentionAssets,
    createAlmightyPromptTextTokens,
    pruneAlmightyPromptMentionTokensByAssetIds,
    serializeAlmightyPromptMentionTokens,
    type AlmightyPromptMentionToken,
} from '~/utils/almightyMention'
import {
    aspectRatioEnums,
    videoSizeEnums,
    formatAndGroupData,
} from '~/utils/common'
import {
    isAlmightyReferenceSupported,
    isDance25Model,
    isDurationSliderSupported,
} from '~/utils/videoModelCapabilities'
import { emitter, emitRecommendPrompt, emitSelectedModelData } from '~/utils/emitter'
import { useMediaQuery } from '@vueuse/core'
const appStore = useAppStore()
const modelData = computed(() => appStore.modelData)
const isLt1024 = useMediaQuery('(max-width: 1023.98px)')

const { t, locale } = useI18n()
const ALMIGHTY_PROMPT_MAX_LENGTH = 1000
const props = withDefaults(
    defineProps<{
        type: any
        create_btn_disable: boolean
        create_loading: boolean
        recommend_list: Array<any>
    }>(),
    {
        type: 'text_to_video',
        create_btn_disable: false,
        create_loading: false,
        recommend_list: () => [],
    }
)

const edit_model = defineModel('edit_model', {
    type: String,
    default: '',
})

const edit_prompt = defineModel('edit_prompt', {
    type: String,
    default: '',
})

const edit_aspect_ratio = defineModel('edit_aspect_ratio', {
    type: String,
    default: '',
})

const edit_output_image_number = defineModel('edit_output_image_number', {
    type: Number,
    default: 1,
})

const video_size = defineModel('video_size')
const duration = defineModel<number | null>('duration')
const negative_prompt = defineModel('negative_prompt', {
    type: String,
    default: '',
})
const generate_audio = defineModel('generate_audio', {
    type: Boolean,
    default: true,
})
const image_url = defineModel('image_url', {
    type: String,
    default: '',
})
const image_list = defineModel('image_list', {
    type: Array<string>,
    default: () => [],
})
const image_type = defineModel('image_type', {
    type: String,
    default: 'single_frame',
})

const frame_end_mode = defineModel('frame_end_mode', {
    type: Boolean,
    default: false,
})

const first_image_url = defineModel('first_image_url', {
    type: String,
    default: '',
})
const last_image_url = defineModel('last_image_url', {
    type: String,
    default: '',
})

const is_seedance_allround_mode = defineModel<boolean>(
    'is_seedance_allround_mode',
    {
        default: false,
    }
)

const almighty_reference_items = defineModel<AlmightyReferenceItem[]>(
    'almighty_reference_items',
    {
        default: () => [],
    }
)

const almighty_prompt_tokens = defineModel<AlmightyPromptMentionToken[]>(
    'almighty_prompt_tokens',
    {
        default: () => [],
    }
)

const almighty_busy = defineModel<boolean>('almighty_busy', {
    default: false,
})

const model_version = defineModel('model_version', {
    type: String,
    default: '',
})

const public_visible = defineModel('public_visible', {
    type: Boolean,
    default: true,
})
const copyright_protection = defineModel('copyright_protection', {
    type: Boolean,
    default: false,
})

const upload_image_limit = ref<number>(3)

const aspectRatioList = ref<Array<any> | null>(null)
const durationList = ref<Array<any> | null>(null)
const resolutionList = ref<Array<any> | null>(null)
const has_negative_prompt = ref(false)
const prompt_length_limit = ref<number>(5000)
const currentModelList = ref<any>(null)
const userSelectedSeedanceReferenceMode = ref(false)
const allroundRecommendLoading = ref(false)
const allroundRecommendVisible = ref(false)
const allroundRecommendForceOpen = ref(false)
const allroundAiReversalVisible = ref(false)
const isClient = ref(false)
const modelList = computed(() => {
    if (!modelData.value) return []

    const arr = modelData.value?.video_models?.[props.type] || {}
    const finalData = formatAndGroupData(arr)

    // 只有当 edit_model.value 完全为空且没有设置任何值时，才设置默认值
    // 如果已经通过路由参数或其他方式设置了值，就不再覆盖
    if (!edit_model.value && finalData.length > 0) {
        // 注释掉默认选择逻辑，让父组件控制默认值
        // edit_model.value = finalData[0]?.model_key || ''
    }
    return finalData
})

const current_model_data = ref<any>(null)

// 是否是支持多图编辑
const is_support_multiple_images = computed(() => {
    // 如果model_version存在，则查model_version_list里面的model_key是否等于model_version
    if (model_version.value) {
        const same_ = currentModelList.value?.find(
            (it: any) => it.model_key === model_version.value
        )
        return same_?.is_support_multiple_images
    }

    return current_model_data.value?.is_support_multiple_images
})

const is_support_first_last_frame = computed(() => {
    // 如果model_version存在，则查model_version_list里面的model_key是否等于model_version
    if (model_version.value) {
        const same_ = currentModelList.value?.find(
            (it: any) => it.model_key === model_version.value
        )
        return same_?.is_support_first_last_frame
    }

    return current_model_data.value?.is_support_first_last_frame
})

const is_show_multiple_images_upload = computed(() => {
    return (
        is_support_multiple_images.value &&
        image_type.value === 'multiple_frames'
    )
})

const has_generate_audio = computed(() => {
    return current_model_data.value?.has_generate_audio
})

// 判断是否是 Runway 模型（支持滑块选择时长）
const isRunwayModel = computed(() => {
    return edit_model.value === 'RUNWAY' || edit_model.value === 'RUNWAY_4_5'
})

const supportsDurationSlider = computed(() => {
    return (
        isDurationSliderSupported(effectiveModelKey.value) ||
        supportsAlmightyReference.value
    )
})

const durationSliderOptions = computed(() => {
    if (!Array.isArray(durationList.value)) return []
    return durationList.value
        .map(item => Number(item))
        .filter(item => Number.isFinite(item))
})

const durationSliderMin = computed(() => {
    return durationSliderOptions.value[0] ?? 2
})

const durationSliderMax = computed(() => {
    return (
        durationSliderOptions.value[durationSliderOptions.value.length - 1] ??
        10
    )
})

const durationSliderDefaultValue = computed(() => {
    if (isRunwayModel.value) return 5
    return durationSliderOptions.value[0] ?? 5
})

const effectiveModelKey = computed(() => {
    return model_version.value || edit_model.value
})

const supportsAlmightyReference = computed(() => {
    return isAlmightyReferenceSupported(effectiveModelKey.value)
})

const almightyVideoDurationTotal = computed(() => {
    return almighty_reference_items.value
        .filter(item => item.kind === 'video')
        .reduce((sum, item) => {
            return sum + Math.max(0, Number(item.duration || 0))
        }, 0)
})

const almightyMentionAssets = computed(() => {
    return buildAlmightyMentionAssets(
        almighty_reference_items.value,
        t,
        locale.value
    )
})

const creditDuration = computed(() => {
    if (!is_seedance_allround_mode.value) return duration.value
    return (
        toAlmightyRequestDuration(almightyVideoDurationTotal.value) +
        Math.max(0, Number(duration.value || 0))
    )
})

const almightyModeLabel = computed(() => {
    return localeText(
        'Reference mode',
        '参考模式'
    )
})

const almightyModeText = computed(() => {
    return localeText('All-round reference', '全能参考')
})

const firstLastModeText = computed(() => {
    return localeText('First-last frame', '首尾帧')
})

const almightyPromptPlaceholder = computed(() => {
    return localeText(
        'Upload 1-12 reference assets. Enter text and @ assets to freely combine them, e.g. use @image1 to imitate @video1 with @audio1.',
        '上传1-12个参考素材。输入文字并@素材即可自由组合，例如：@图片1模仿@视频1用@音频1。'
    )
})

const allroundRecommendTooltipDisabled = computed(() => {
    if (allroundRecommendLoading.value) return true
    const hasRecommend = (props.recommend_list?.length || 0) > 0
    return !allroundRecommendForceOpen.value && !hasRecommend
})

const recommendPopperStyle =
    'font-size:13px;color:#fff;padding:20px;background: #333643;border-radius:16px;border:none;z-index:40'

const applyAllroundPromptText = (value: string) => {
    edit_prompt.value = value
    almighty_prompt_tokens.value = createAlmightyPromptTextTokens(value)
}

const handleClickAllroundRecommendPrompt = () => {
    allroundRecommendLoading.value = true
    allroundRecommendForceOpen.value = true
    allroundRecommendVisible.value = false
    emitRecommendPrompt()
}

const applyAllroundRecommendPrompt = (item: string) => {
    applyAllroundPromptText(item)
    allroundRecommendForceOpen.value = false
    allroundRecommendVisible.value = false
}

const handleResetAllroundRecommendLoading = () => {
    allroundRecommendLoading.value = false
    if (allroundRecommendForceOpen.value) {
        nextTick(() => {
            allroundRecommendVisible.value = true
        })
    }
}

const handleShowAllroundAIReversal = () => {
    allroundAiReversalVisible.value = true
}

const handleApplyAllroundReversalPrompt = (item: string) => {
    applyAllroundPromptText(item)
}

// 判断是否是 Sora 2 模型
const isSora2 = computed(() => {
    return (
        edit_model.value === 'SORA_2' ||
        edit_model.value === 'SORA_2_PRO' ||
        model_version.value === 'SORA_2' ||
        model_version.value === 'SORA_2_PRO'
    )
})

const currentWorkflowType = computed(() => {
    if (is_seedance_allround_mode.value) {
        return 'almightyReferenceToVideo'
    }
    if (frame_end_mode.value) {
        return 'firstLastImgToVideo'
    } else if (is_show_multiple_images_upload.value) {
        return 'multiImgToVideo'
    } else {
        return 'imageToVideo'
    }
})

const disableAspectRatio = ref(false)

const localeText = (enText: string, zhText: string) => {
    return locale.value.toLowerCase().startsWith('zh') ? zhText : enText
}

const resetStandardReferences = () => {
    image_url.value = ''
    image_list.value = []
    first_image_url.value = ''
    last_image_url.value = ''
    frame_end_mode.value = false
    image_type.value = 'single_frame'
}

const resetAlmightyReferences = () => {
    almighty_reference_items.value = []
    almighty_prompt_tokens.value = []
    almighty_busy.value = false
}

const activateFirstLastMode = () => {
    userSelectedSeedanceReferenceMode.value = true
    is_seedance_allround_mode.value = false
    almighty_prompt_tokens.value = createAlmightyPromptTextTokens(
        edit_prompt.value || ''
    )
    image_type.value = 'single_frame'
    frame_end_mode.value = true
    image_url.value = first_image_url.value || image_url.value
}

const activateAlmightyMode = (markUserSelection = true) => {
    if (markUserSelection) {
        userSelectedSeedanceReferenceMode.value = true
    }
    is_seedance_allround_mode.value = true
    if (!almighty_prompt_tokens.value.length && edit_prompt.value) {
        almighty_prompt_tokens.value = createAlmightyPromptTextTokens(
            edit_prompt.value
        )
    }
    image_type.value = 'single_frame'
    frame_end_mode.value = false
    first_image_url.value = ''
    last_image_url.value = ''
}

const syncAllroundPromptMentionsWithReferenceItems = () => {
    if (!is_seedance_allround_mode.value) return

    const validAssetIds = almighty_reference_items.value
        .filter(item => typeof item.id === 'string' && !!item.id && !item.loading && !!item.url)
        .map(item => item.id)
    const nextTokens = pruneAlmightyPromptMentionTokensByAssetIds(
        almighty_prompt_tokens.value,
        validAssetIds
    )
    const nextPrompt = serializeAlmightyPromptMentionTokens(
        nextTokens,
        almightyMentionAssets.value
    )

    if (
        JSON.stringify(nextTokens) ===
        JSON.stringify(almighty_prompt_tokens.value) &&
        edit_prompt.value === nextPrompt
    ) {
        return
    }

    almighty_prompt_tokens.value = nextTokens
    edit_prompt.value = nextPrompt
}

// 控制是否显示比例选择组件（KLING_O1 模型特殊处理：不显示比例选择）
const shouldShowAspectRatio = computed(() => {
    // KLING_O1 模型为帧转视频时不显示比例选择
    if (
        edit_model.value === 'KLING_O1' &&
        image_type.value === 'single_frame'
    ) {
        return false
    }
    return displayedAspectRatioList.value.length > 0
})

const isDance25FirstLastFrameMode = computed(() => {
    if (!frame_end_mode.value) return false
    return [model_version.value, edit_model.value].some(key => isDance25Model(key))
})

const displayedAspectRatioList = computed(() => {
    return isDance25FirstLastFrameMode.value ? ['adaptive'] : (aspectRatioList.value || [])
})

watch(
    displayedAspectRatioList,
    ratios => {
        if (!ratios.length) return
        if (!ratios.includes(edit_aspect_ratio.value)) {
            edit_aspect_ratio.value = ratios[0]
        }
    },
    { immediate: true }
)

// 计算需要禁用的比例列表
const disabledAspectRatios = computed(() => {
    // 仅在 multiple_frames 且模型为 VEO_3_1 时禁用 9:16 比例（只支持 16:9）
    // 其他场景（single_frame 或其他模型）不禁用 9:16
    if (
        model_version.value === 'VEO_3_1' &&
        image_type.value === 'multiple_frames'
    ) {
        return ['9:16']
    }
    return []
})

const getCurrentSettingData = (same_: any) => {
    // frame_end_mode.value =
    if (!same_.is_support_first_last_frame) {
        frame_end_mode.value = false
    }

    emitSelectedModelData(same_)

    aspectRatioList.value = same_?.aspect_ratios

    // 如果当前模型版本是 VEO_3_1 且是 multiple_frames 模式，且当前选中的比例是 9:16，则自动切换到第一个可用比例
    // 因为 VEO_3_1 在 multiple_frames 模式下不支持 9:16
    if (
        model_version.value === 'VEO_3_1' &&
        image_type.value === 'multiple_frames' &&
        edit_aspect_ratio.value === '9:16'
    ) {
        // 找到第一个不是 9:16 的比例，优先选择 16:9
        const availableRatio =
            aspectRatioList.value?.find((ratio: string) => ratio !== '9:16') ||
            aspectRatioList.value?.[0] ||
            ''

        edit_aspect_ratio.value = availableRatio
    } else if (
        !edit_aspect_ratio.value ||
        !aspectRatioList.value?.includes(edit_aspect_ratio.value)
    ) {
        // 如果当前没有选中比例或选中的比例不在列表中，则选择第一个可用比例
        edit_aspect_ratio.value = aspectRatioList.value?.[0] || ''
    }
    // 如果当前选中的比例有效，则保持不变

    const durations = same_?.durations || []
    durationList.value = isDance25Model(
        same_?.model_key || model_version.value || edit_model.value
    )
        ? durations.filter((item: unknown) => {
              const value = Number(item)
              return Number.isFinite(value) && value >= 4 && value <= 30
          })
        : durations
    // 如果是 Runway 模型，默认选中 5；否则选择第一个
    if (edit_model.value === 'RUNWAY' || edit_model.value === 'RUNWAY_4_5') {
        duration.value = 5
    } else {
        duration.value = durationList.value?.[0]
    }
    resolutionList.value = same_?.resolutions
    video_size.value = resolutionList.value?.[0] || ''
    prompt_length_limit.value = same_?.prompt_length_limit || 5000
    has_negative_prompt.value = Boolean(same_?.has_negative_prompt)
    if (!has_negative_prompt.value) {
        negative_prompt.value = ''
    }

    const selectedModelKey = same_?.model_key || model_version.value || edit_model.value
    const shouldKeepFirstLastMode =
        isAlmightyReferenceSupported(selectedModelKey) &&
        !is_seedance_allround_mode.value &&
        frame_end_mode.value &&
        same_?.is_support_first_last_frame

    // 针对 google-veo3-1 (VEO_3_1)、PIKA_2_2 和 Seedance 首尾帧模式，保持帧转视频（single_frame）
    if (
        edit_model.value === 'google-veo3-1' ||
        model_version.value === 'VEO_3_1' ||
        edit_model.value === 'PIKA_2_2' ||
        shouldKeepFirstLastMode
    ) {
        image_type.value = 'single_frame'
    } else {
        if (!is_seedance_allround_mode.value) {
            image_type.value = same_?.is_support_multiple_images
                ? 'multiple_frames'
                : 'single_frame'
        }
    }
}

watch(
    [() => edit_model.value, () => modelData.value],
    ([newVal, newVal2]: [string, any]) => {
        if (newVal && newVal2) {
            const same_ = modelList.value?.find(
                (it: any) => it.model_key === newVal
            )
            // reset image_type to single_frame
            if (!is_seedance_allround_mode.value) {
                image_type.value = 'single_frame'
            }
            current_model_data.value = same_
            currentModelList.value = same_?.model_version_list || []

            // 如果当前 model_version 已存在且在列表中，保持不变；否则设置默认值
            const currentVersion = model_version.value
            const isVersionInList = currentModelList.value?.find(
                (v: any) => v.model_key === currentVersion
            )

            if (!currentVersion || !isVersionInList) {
                model_version.value =
                    currentModelList.value?.[0]?.model_key || ''
            }
            const activeSetting = model_version.value
                ? currentModelList.value?.find(
                      (v: any) => v.model_key === model_version.value
                  )
                : null
            getCurrentSettingData(activeSetting || same_)
        }
    },
    {
        immediate: true,
        flush: 'post',
    }
)

watch(
    [() => model_version.value, () => currentModelList.value],
    ([newVal, newVal2]: [string, any[]]) => {
        if (newVal && newVal2) {
            const same_ = currentModelList.value?.find(
                (it: any) => it.model_key === newVal
            )
            same_ && getCurrentSettingData(same_)
        }
    }
)

watch(
    () => supportsAlmightyReference.value,
    supported => {
        if (!supported) {
            if (is_seedance_allround_mode.value) {
                is_seedance_allround_mode.value = false
                resetAlmightyReferences()
                frame_end_mode.value = false
            }
            userSelectedSeedanceReferenceMode.value = false
            return
        }

        if (supported && !userSelectedSeedanceReferenceMode.value) {
            activateAlmightyMode(false)
        }
    },
    {
        immediate: true,
    }
)

watch(
    () => is_seedance_allround_mode.value,
    enabled => {
        if (enabled) {
            activateAlmightyMode(false)
            return
        }
        if (!supportsAlmightyReference.value) {
            resetAlmightyReferences()
        }
    }
)

watch(
    almighty_reference_items,
    () => {
        syncAllroundPromptMentionsWithReferenceItems()
    },
    {
        deep: true,
    }
)

watch(
    () => edit_prompt.value,
    nextPrompt => {
        if (!is_seedance_allround_mode.value) return
        if (almighty_prompt_tokens.value.length > 0) return
        almighty_prompt_tokens.value = createAlmightyPromptTextTokens(
            nextPrompt || ''
        )
    }
)

watch(
    () => allroundRecommendVisible.value,
    visible => {
        if (!visible && !allroundRecommendLoading.value) {
            allroundRecommendForceOpen.value = false
        }
    }
)

// 监听 image_type 变化，当切换到 multiple_frames 且模型是 VEO_3_1 时，如果当前选中的是 9:16，自动切换
watch(
    () => image_type.value,
    newVal => {
        if (
            newVal === 'multiple_frames' &&
            model_version.value === 'VEO_3_1' &&
            edit_aspect_ratio.value === '9:16' &&
            aspectRatioList.value?.length
        ) {
            // 找到第一个不是 9:16 的比例，优先选择 16:9
            const availableRatio =
                aspectRatioList.value?.find(
                    (ratio: string) => ratio !== '9:16'
                ) ||
                aspectRatioList.value?.[0] ||
                ''
            if (availableRatio) {
                edit_aspect_ratio.value = availableRatio
            }
        }
    }
)

onMounted(async () => {
    emitter.on('reset-recommend-loading', handleResetAllroundRecommendLoading)
    if (typeof window !== 'undefined') {
        try {
            const { dotSpinner } = await import('ldrs')
            dotSpinner.register()
        } catch (error) {
            console.error('Failed to load ldrs:', error)
        } finally {
            isClient.value = true
        }
    }
})

onUnmounted(() => {
    emitter.off('reset-recommend-loading', handleResetAllroundRecommendLoading)
})

defineExpose({
    getCurrentSettingData,
})
</script>
<style scoped lang="less">
.setting-side {
    width: 100%;
    height: 100%;
    background-color: #222222;
}

.almighty-mode-switch__tabs {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
}

.almighty-mode-switch__tab {
    height: 40px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.03);
    color: rgba(255, 255, 255, 0.76);
    font-size: 13px;
    transition: all 0.2s ease;
}

.almighty-mode-switch__tab--active {
    border-color: rgba(255, 255, 255, 0.22);
    background: rgba(255, 255, 255, 0.1);
    color: white;
}

.allround-prompt-shell {
    position: relative;
    width: 100%;
    min-height: 127px;
    padding: 10px 10px 36px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 8px;
    background: #1c1c20;
    transition: border-color 0.2s ease;

    &:hover,
    &:focus-within {
        border-color: rgba(255, 255, 255, 0.3);
    }
}

.allround-prompt-shell__actions {
    position: absolute;
    left: 10px;
    bottom: 8px;
    display: inline-flex;
    align-items: center;
    gap: 20px;
    color: #adadad;
    z-index: 2;
}

.allround-prompt-shell__action {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #adadad;
    font-size: 12px;
    line-height: 1;
    cursor: pointer;
    transition: color 0.2s ease;

    &:hover {
        color: #fff;
    }
}

.loading {
    animation: loading 1s linear infinite;
    transition: all 0.2s ease-in-out;
}

@keyframes loading {
    0% {
        transform: rotate(0deg);
        color: var(--weryai-text-active);
    }

    100% {
        transform: rotate(360deg);
        color: var(--weryai-text-active);
    }
}
</style>
